module.exports = __webpack_public_path__ + "d48721f6f0825524964f14484f81def7.svg";


//////////////////
// WEBPACK FOOTER
// ./wwwroot/fonts/fontawesome-webfont.svg?v=4.6.3
// module id = 26
// module chunks = 0